import { RichTextBlockNode } from '@cinemark/content-api-client';
import { SerializedElementNode } from '@payloadcms/richtext-lexical/lexical';
import { NodesToJSX } from './rich-text-renderer';

type RichTextLandmarkConverterComponentProps = {
  node: SerializedElementNode | undefined;
  nodesToJSX: NodesToJSX;
};

export const RichTextLandmarkConverterComponent = ({ node, nodesToJSX }: RichTextLandmarkConverterComponentProps): React.JSX.Element | null => {
  if (!node || node.type !== 'landmark' || !node.children?.length) return null;

  const children = nodesToJSX({ nodes: node.children ?? [] });

  const landmarkNode = node as unknown as RichTextBlockNode;

  return (
    <span id={landmarkNode.id}>{children}</span>
  );
};
